export default __webpack_public_path__ + "static/media/whatsapp.f179709d.svg";